import React from 'react';
import { ListGroup } from 'reactstrap';

import CircularLoading from '../../Common/CircularLoading/CircularLoading';
import SignUpBibsListItem from './SignUpBibsListItem';

const ratingExamMapper = {
  E5: '2',
  E6: '1',
};

class SignUpBibs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // quals: false,
      // collapse: false,
      // qualId: null,
      pfeReferences: false,
    };
  }
  // toggle(id) {
  //   this.setState({
  //     qualId: id,
  //   });

  //   if (this.state.collapse && this.state.qualId === id) {
  //     this.setState({
  //       collapse: false,
  //     });
  //   } else {
  //     this.setState({
  //       collapse: true,
  //     });
  //   }
  // }

  // renderReferences = (references, qual) => {
  //   if (qual) {
  //     return references.map((reference) => (
  //       <ListGroup key={reference.id}>
  //         <SignUpBibsListItem reference={reference} qual={qual} />
  //       </ListGroup>
  //     ));
  //   }

  renderReferences = (references) => {
    const referencesWithQuestions = references
      .filter(
        (reference) =>
          // get reference with at least one chapter
          Array.isArray(reference.chapters) && reference.chapters.length > 0,
      )
      .map((reference) => {
        // get chapters with questions. If there is not chapters with questions then set empty array.
        reference.chapters = reference.chapters.filter(
          (chapter) => chapter.questionCount > 0,
        );
        return reference;
      })
      .filter(
        (reference) =>
          // get only references with questions
          reference.chapters.length,
      );

    return referencesWithQuestions.map((reference) => (
      <ListGroup key={reference.id}>
        {/* use this if quals functionality available
        <SignUpBibsListItem reference={reference} qual={qual} /> */}
        <SignUpBibsListItem reference={reference} qual={false} />
      </ListGroup>
    ));
  };

  // renderQuals = (quals) =>
  //   quals.map((qual) => (
  //     <div key={qual.id}>
  //       <div>
  //         <h4>
  //           <Row>
  //             <Col lg={6}>{qual.name}</Col>
  //             <Col lg={6}>
  //               {qual.references && qual.references.length > 0 && (
  //                 <button
  //                   className="ml-3 btn btn-outline-primary flex-row rounded-lg"
  //                   onClick={() => this.toggle(qual.id)}
  //                 >
  //                   <i
  //                     className={
  //                       this.state.collapse && this.state.qualId === qual.id
  //                         ? 'icon-expand mr-1 rotate down'
  //                         : 'icon-expand mr-1 rotate'
  //                     }
  //                   />
  //                   {this.state.collapse && this.state.qualId === qual.id
  //                     ? 'COLLAPSE'
  //                     : 'EXPAND'}
  //                 </button>
  //               )}
  //             </Col>
  //           </Row>
  //         </h4>
  //         {this.state.collapse && this.state.qualId === qual.id && (
  //           <Collapse isOpen={this.state.collapse}>
  //             {this.renderReferences(qual.references, true)}
  //           </Collapse>
  //         )}
  //       </div>
  //       <hr />
  //     </div>
  //   ));

  render() {
    const isPfeOnlyAFSCRank =
      this.props.rate?.isPfeOnly ||
      this.props.questionsOccupationalCounter === 0;
    return (
      <div className="signup-bibs">
        {this.props.loadingReferences && (
          <div className="loading-container">
            <CircularLoading className="loading-references-gif" />
            <div className="loading-text">loading references</div>
          </div>
        )}
        {!this.props.loadingReferences &&
          (this.props.chaptersCount > 0 || this.props.chaptersPmkCount > 0) &&
          this.props.rate.id !== 0 &&
          this.props.rank !== '' &&
          this.props.dutyState !== '' && (
            <div className="signup-bibs-body">
              <div className="signup-bibs-title">What we have to offer:</div>
              <div className="gray-divider" />

              {/* EXAM NAME */}
              <div className="exam">
                {this.props.rate.shortname}
                {ratingExamMapper[this.props.rank]} exam{' '}
                {this.props.cycle.title}
              </div>

              {/* PFE and SKT REFERENCES */}
              <div className="references-container">
                <div className="counters">
                  {!isPfeOnlyAFSCRank &&
                    ` ${this.props.questionsOccupationalCounter} study questions available from ${this.props.chaptersCount} SKT reference items.`}
                </div>
                <div className="counters">
                  {`${parseFloat(
                    this.props.questionsPmkCounter,
                  ).toLocaleString()}
                  study questions available from ${
                    this.props.chaptersPmkCount -
                    this.props.chaptersPmkWithoutQuestions
                  } PFE reference items.`}
                </div>

                <div className="options-container">
                  {!isPfeOnlyAFSCRank ? (
                    <>
                      <div
                        className={
                          // !this.state.quals &&
                          !this.state.pfeReferences
                            ? 'subtitle active'
                            : 'subtitle desactive'
                        }
                        onClick={() => {
                          this.setState({
                            // quals: false,
                            pfeReferences: false,
                          });
                        }}
                      >
                        SKT references
                      </div>
                      <div
                        className={
                          this.state.pfeReferences
                            ? 'subtitle active ml-1'
                            : 'subtitle desactive ml-1'
                        }
                        onClick={() => {
                          this.setState({
                            // quals: false,
                            pfeReferences: true,
                          });
                        }}
                      >
                        PFE References
                      </div>
                      {/* <div
                        className={
                          this.state.quals
                            ? 'subtitle active ml-1'
                            : 'subtitle desactive ml-1'
                        }
                        onClick={() => {
                          this.setState({
                            quals: true,
                            pfeReferences: false,
                          });
                        }}
                      >
                        Warfare and Qualification References
                      </div> */}
                    </>
                  ) : (
                    <>
                      <div className="subtitle active ml-1">PFE References</div>
                      {/* <div
                        className={
                          this.state.quals
                            ? 'subtitle active ml-1'
                            : 'subtitle desactive ml-1'
                        }
                        onClick={() => {
                          this.setState({
                            quals: true,
                            pfeReferences: false,
                          });
                        }}
                      >
                        Warfare and Qualification References
                      </div> */}
                    </>
                  )}
                </div>
                {isPfeOnlyAFSCRank ? (
                  // !this.state.quals ? (
                  <div>{this.renderReferences(this.props.referencesPmk)}</div>
                ) : // ) : (
                //     <div className="quals mt-2">
                //       {this.renderQuals(this.props.contentByWarfareQuals)}
                //     </div>
                //   )
                this.state.pfeReferences ? (
                  <div className="quals mt-2">
                    {this.renderReferences(this.props.referencesPmk)}
                  </div>
                ) : (
                  // this.state.quals ? (
                  //     <div className="quals mt-2">
                  //       {this.renderQuals(this.props.contentByWarfareQuals)}
                  //     </div>
                  //   ) :
                  <div>{this.renderReferences(this.props.references)}</div>
                )}
              </div>
            </div>
          )}
      </div>
    );
  }
}

export default SignUpBibs;
